'use strict';

import template from './template.html';


export default function() {
	return {
		scope: {
			userList: '<',
			ngModel: '=',
			required: '<',
		},
		template: template,
	};
}
